import fetch from "../utilities/fetch"

export const requestGetAllXRays = () => fetch.get("/result/")
export const requestDeleteXRay = (id: string) => fetch.delete(`/result/${id}/`)
